import { debounce } from "lodash-es";
import { BehaviorSubject } from "rxjs";
import { ModelEventBus } from "../../event-bus";
import RappidContext from "../rappid/rappid-context";
import GeneratorModelState from "./generation/generator-model-state";
import { editorStateStore } from "./storage/editor-state-store";

export class DirtyState {
  observable: BehaviorSubject<boolean>;
  static listenForChange = true;

  constructor(
    private rappidContext: RappidContext,
    private generatorModelState: GeneratorModelState
  ) {
    this.observable = new BehaviorSubject<boolean>(false);
  }

  isDirty(): boolean {
    return this.observable.value;
  }

  setDirty(value: boolean): void {
    this.observable.next(value);
  }

  debounceFn = debounce(
    () => {
      ModelEventBus.emit("modelChanged");
    },
    1000,
    {
      leading: false,
      trailing: true,
    }
  );

  activate(): void {
    this.rappidContext.graph.on("add remove", () => {
      this.triggerDirtyState();
    });

    this.rappidContext.graph.on("change", (_cell, context) => {
      if ("propertyPath" in context) {
        const prop = context["propertyPath"];
        // to prevent triggering dirty state on transition properties show/hide

        if (prop !== "labels/1") {
          this.triggerDirtyState();
        }
      } else {
        this.triggerDirtyState();
      }
    });

    // not letting show/hide transition properties triggering dirtyState is preventing as well saving of changed order of prioritites, so seperate listener needed
    ModelEventBus.on("prioritiesChanged", this.triggerDirtyState.bind(this));

    // generatorModelState not saved anywhere so can be as well deactivated
    // this.generatorModelState.observable.subscribe(() => {
    //   this.setDirty(true);
    // });

    ModelEventBus.on("modelValidated", this.cleanDirtyState.bind(this));

    window.addEventListener("beforeunload", (e): void => {
      if (this.isDirty()) {
        e.preventDefault();
        e.returnValue = "";
      }
    });
  }

  triggerDirtyState() {
    if (DirtyState.listenForChange) {
      this.setDirty(true);
      this.debounceFn();
    }
  }

  cleanDirtyState() {
    // check for validation counter to prevent, on low network connection, an early setting of dirty state to false, if another validation is still running
    if (editorStateStore().getValidationTriggerCounter === 0) {
      this.setDirty(false);
    }
  }
}
